/* eslint-disable no-magic-numbers */
import Modal from "@/components/modal/modal.vue";

import { GUEST_COUNT_STRATEGY } from "@/enums";

export default {
	components: { Modal },

	props: {
		stsName: String,
		stLabels: Array,
		gcStrategy: String,
		gcDefaults: Array,
		target: String,
		date: String,
	},

	data() {
		return {
			form: this.gcDefaults ? [...this.gcDefaults] : Array(6).fill(null),

			GUEST_COUNT_STRATEGY,
		};
	},

	methods: { save },
};

function save() {
	this.$emit("save", this.target, this.form);
}
